import { View, styled } from 'lib_ui-primitives';
export const TransactionLayout = styled(View).attrs({ name: 'transaction-layout' })`
    flex-grow: 1;
`;
TransactionLayout.displayName = 'TransactionLayout';
